/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileFormatHtmlIcon16Light } from './FileFormatHtmlIcon16Light';
import { FileFormatHtmlIcon16Regular } from './FileFormatHtmlIcon16Regular';
import { FileFormatHtmlIcon16Solid } from './FileFormatHtmlIcon16Solid';
import { FileFormatHtmlIcon20Light } from './FileFormatHtmlIcon20Light';
import { FileFormatHtmlIcon20Regular } from './FileFormatHtmlIcon20Regular';
import { FileFormatHtmlIcon20Solid } from './FileFormatHtmlIcon20Solid';
import { FileFormatHtmlIcon24Regular } from './FileFormatHtmlIcon24Regular';
import { FileFormatHtmlIcon24Solid } from './FileFormatHtmlIcon24Solid';
import { FileFormatHtmlIcon32Regular } from './FileFormatHtmlIcon32Regular';
import { FileFormatHtmlIcon64Regular } from './FileFormatHtmlIcon64Regular';
var sizes = {
    16: {
        light: FileFormatHtmlIcon16Light,
        regular: FileFormatHtmlIcon16Regular,
        solid: FileFormatHtmlIcon16Solid,
    },
    20: {
        light: FileFormatHtmlIcon20Light,
        regular: FileFormatHtmlIcon20Regular,
        solid: FileFormatHtmlIcon20Solid,
    },
    24: {
        regular: FileFormatHtmlIcon24Regular,
        solid: FileFormatHtmlIcon24Solid,
    },
    32: {
        regular: FileFormatHtmlIcon32Regular,
    },
    64: {
        regular: FileFormatHtmlIcon64Regular,
    },
};
export var FileFormatHtmlIcon = forwardRef('FileFormatHtmlIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
